import { get } from '@/helpers/apiRequest';

export default {
  data() {
    return {
      items: [],
      loading: false,
      erroCarga: null,
      paginator: {},
      filtrosAbertos: false,
    };
  },

  computed: {
    chipsFiltros() {
      return Object.entries(this.filtros || {})
        .filter(([, valor]) => valor !== '' && valor !== null && valor !== undefined)
        .map(([chave, valor]) => ({
          chave,
          rotulo: (this.rotulosFiltros || {})[chave] || chave,
          valor: this.descreverFiltro(chave, valor),
        }));
    },

    totalFiltrosAtivos() {
      return this.chipsFiltros.length;
    },
  },

  beforeMount() { this.load(); },

  methods: {
    load(page = 1) {
      this.loading = true;
      this.erroCarga = null;
      const seq = (this._loadSeq = (this._loadSeq || 0) + 1);
      const params = this.buildListagemParams(page);
      return get(`${this.listagemEndpoint}?${params}`)
        .then(json => {
          if (seq !== this._loadSeq) return;
          this.items = json.itens || json.data || json;
          if (json.paginator) this.paginator = json.paginator;
        })
        .catch(err => {
          if (seq !== this._loadSeq) return;
          this.erroCarga = (err && err.message) || 'Erro ao carregar';
          this.avisarErroCarga();
        })
        .finally(() => {
          if (seq === this._loadSeq) this.loading = false;
        });
    },

    avisarErroCarga() {
      if (this.erroCargaNaTela || !this.$swal) return;
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: 'Não foi possível atualizar a lista',
        text: this.erroCarga,
        showConfirmButton: false,
        timer: 3500,
        timerProgressBar: true,
      });
    },

    buildListagemParams(page) {
      const params = new URLSearchParams({ page });
      if (this.sort) {
        params.append('sortBy', this.sort.by);
        params.append('sortType', this.sort.dir);
      }
      if (this.filtros && this.filtros.integracaoId) {
        params.append('integracao_id', this.filtros.integracaoId);
      }
      this.appendFiltros(params);
      return params;
    },

    onFabricanteChange() {
      this.filtros.integracaoId = '';
      this.load();
    },

    descreverFiltro(chave, valor) {
      return valor;
    },

    nomeDaOpcao(lista, id) {
      const opcao = (lista || []).find((item) => String(item.id) === String(id));
      return opcao ? opcao.nome : id;
    },

    removerFiltro(chave) {
      this.filtros[chave] = '';
      this.load(1);
    },

    limparFiltros() {
      Object.keys(this.filtros).forEach((chave) => { this.filtros[chave] = ''; });
      this.load(1);
    },

    appendFiltros(params) {
      if (this.filtros.fabricanteId) params.append('fabricante_id', this.filtros.fabricanteId);
      if (this.filtros.termo) params.append('q', this.filtros.termo);
    },

    sortBy(column) {
      if (this.sort.by === column) {
        this.sort.dir = this.sort.dir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.by = column;
        this.sort.dir = 'asc';
      }
      this.load(1);
    },
  },
};
